import React from 'react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Search, Download } from 'lucide-react';
const sampleTxns = [{
  txnId: 'TXN-BK-893421',
  ticketId: 'CHMB-20260519-0001',
  gateway: 'bKash',
  amount: '৳৪০',
  status: 'Success',
  time: '১০:১৬ AM',
  ref: 'BKASH9X21'
}, {
  txnId: 'TXN-NG-441982',
  ticketId: 'CHMB-20260519-0002',
  gateway: 'Nagad',
  amount: '৳৮০',
  status: 'Success',
  time: '১০:২৩ AM',
  ref: 'NGD77A12'
}, {
  txnId: 'TXN-BK-118734',
  ticketId: 'CHMB-20260519-0003',
  gateway: 'bKash',
  amount: '৳২০',
  status: 'Success',
  time: '১০:৩৯ AM',
  ref: 'BKASH1Q44'
}, {
  txnId: 'TXN-NG-992013',
  ticketId: 'CHMB-20260519-0004',
  gateway: 'Nagad',
  amount: '৳১০০',
  status: 'Success',
  time: '১১:০৬ AM',
  ref: 'NGD80F55'
}, {
  txnId: 'TXN-BK-553102',
  ticketId: 'CHMB-20260519-0005',
  gateway: 'bKash',
  amount: '৳৬০',
  status: 'Failed',
  time: '১১:২১ AM',
  ref: 'Failed OTP'
}, {
  txnId: 'TXN-BK-773901',
  ticketId: 'CHMB-20260519-0006',
  gateway: 'bKash',
  amount: '৳২০০',
  status: 'Success',
  time: '১১:৪৬ AM',
  ref: 'BKASH6T91'
}, {
  txnId: 'TXN-NG-210874',
  ticketId: 'CHMB-20260519-0007',
  gateway: 'Nagad',
  amount: '৳৪০',
  status: 'Success',
  time: '১২:১১ PM',
  ref: 'NGD33K20'
}, {
  txnId: 'TXN-BK-900128',
  ticketId: 'CHMB-20260519-0008',
  gateway: 'bKash',
  amount: '৳২০',
  status: 'Success',
  time: '১২:৩১ PM',
  ref: 'BKASH7M09'
}, {
  txnId: 'TXN-NG-661205',
  ticketId: 'CHMB-20260519-0009',
  gateway: 'Nagad',
  amount: '৳৮০',
  status: 'Pending',
  time: '০১:০১ PM',
  ref: 'Pending Confirmation'
}, {
  txnId: 'TXN-BK-330981',
  ticketId: 'CHMB-20260519-0010',
  gateway: 'bKash',
  amount: '৳১০০',
  status: 'Success',
  time: '০১:২৬ PM',
  ref: 'BKASH5P31'
}];
export function Transactions() {
  return <div className="space-y-6" data-id="element-410">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-411">
        <div data-id="element-412">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-413">পেমেন্ট লেনদেন</h1>
          <p className="text-slate-500" data-id="element-414">সকল পেমেন্ট গেটওয়ে লেনদেনের তালিকা</p>
        </div>
        <Button variant="outline" className="gap-2" data-id="element-415">
          <Download className="w-4 h-4" data-id="element-416" />
          এক্সপোর্ট
        </Button>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-wrap gap-4" data-id="element-417">
        <div className="flex-1 min-w-[200px]" data-id="element-418">
          <Input icon={<Search className="w-4 h-4" data-id="element-420" />} placeholder="Transaction ID বা Reference দিয়ে খুঁজুন..." className="h-10" data-id="element-419" />
        </div>
        <Input type="date" className="h-10 w-auto" data-id="element-421" />
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-422">
        <div className="overflow-x-auto" data-id="element-423">
          <table className="w-full text-sm text-left whitespace-nowrap" data-id="element-424">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase" data-id="element-425">
              <tr data-id="element-426">
                <th className="px-6 py-4 font-medium" data-id="element-427">Transaction ID</th>
                <th className="px-6 py-4 font-medium" data-id="element-428">Ticket ID</th>
                <th className="px-6 py-4 font-medium" data-id="element-429">Gateway</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-430">Amount</th>
                <th className="px-6 py-4 font-medium" data-id="element-431">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-432">Time</th>
                <th className="px-6 py-4 font-medium" data-id="element-433">Reference</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-434">
              {sampleTxns.map((txn, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-435">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-436">
                    {txn.txnId}
                  </td>
                  <td className="px-6 py-4 text-slate-500" data-id="element-437">{txn.ticketId}</td>
                  <td className="px-6 py-4" data-id="element-438">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${txn.gateway === 'bKash' ? 'bg-[#e2136e]/10 text-[#e2136e]' : 'bg-[#f7931e]/10 text-[#f7931e]'}`} data-id="element-439">
                      {txn.gateway}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right font-medium text-slate-900" data-id="element-440">
                    {txn.amount}
                  </td>
                  <td className="px-6 py-4" data-id="element-441">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${txn.status === 'Success' ? 'bg-brand-green/10 text-brand-green' : txn.status === 'Failed' ? 'bg-destructive/10 text-destructive' : 'bg-amber-100 text-amber-700'}`} data-id="element-442">
                      {txn.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-slate-500" data-id="element-443">{txn.time}</td>
                  <td className="px-6 py-4 text-slate-500 font-mono text-xs" data-id="element-444">
                    {txn.ref}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}